var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoFilledIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 8.49999C1 4.36074 4.36 1 8.50001 1C12.6475 1 16 4.36074 16 8.49999C16 12.6408 12.6475 16 8.50001 16C4.36 16 1 12.6408 1 8.49999ZM7.84001 5.6575C7.84001 5.29824 8.14001 4.99749 8.50001 4.99749C8.86001 4.99749 9.15251 5.29824 9.15251 5.6575V8.97249C9.15251 9.33324 8.86001 9.62499 8.50001 9.62499C8.14001 9.62499 7.84001 9.33324 7.84001 8.97249V5.6575ZM8.5075 12.0108C8.14001 12.0108 7.8475 11.7107 7.8475 11.3507C7.8475 10.9907 8.14001 10.6983 8.50001 10.6983C8.86751 10.6983 9.16 10.9907 9.16 11.3507C9.16 11.7107 8.86751 12.0108 8.5075 12.0108Z",
    fill: "#2653f11A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84001 5.6575C7.84001 5.29824 8.14001 4.99749 8.50001 4.99749C8.86001 4.99749 9.15251 5.29824 9.15251 5.6575V8.97249C9.15251 9.33324 8.86001 9.62499 8.50001 9.62499C8.14001 9.62499 7.84001 9.33324 7.84001 8.97249V5.6575Z",
    fill: "#2653F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5075 12.0108C8.14001 12.0108 7.8475 11.7107 7.8475 11.3507C7.8475 10.9907 8.14001 10.6983 8.50001 10.6983C8.86751 10.6983 9.16 10.9907 9.16 11.3507C9.16 11.7107 8.86751 12.0108 8.5075 12.0108Z",
    fill: "#2653F1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoFilledIcon);
export default __webpack_public_path__ + "static/media/infoFilledIcon.36f2f75bc08ccef1c1d17f4a973872c3.svg";
export { ForwardRef as ReactComponent };